import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a94b3d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold" }, "Beskrivelse", -1))
const _hoisted_2 = {
  key: 0,
  class: "field-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MarkdownContent = _resolveComponent("MarkdownContent")!
  const _component_MarkdownEditor = _resolveComponent("MarkdownEditor")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.mode === 'view')
      ? (_openBlock(), _createBlock(_component_MarkdownContent, {
          key: 0,
          content: _ctx.value
        }, null, 8, ["content"]))
      : (_ctx.mode === 'edit')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_MarkdownEditor, {
              editorOptions: {min_height: 450,},
              extensions: { table: true },
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event))
            }, null, 8, ["modelValue"]),
            (_ctx.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.error), 1))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
  ]))
}